"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RefreshIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.874 1.2a6.874 6.874 0 100 13.747h.982a.982.982 0 000-1.963h-.982a4.91 4.91 0 114.91-4.91h-1.761a.491.491 0 00-.347.838l2.742 2.742a.49.49 0 00.695 0l2.742-2.742a.491.491 0 00-.347-.838h-1.76A6.874 6.874 0 006.874 1.2z"
  })))
});
RefreshIcon.displayName = 'RefreshIcon';
var _default = exports.default = RefreshIcon;